module.exports = __webpack_public_path__ + "static/img/bean_ten.d3ef69e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bean_ten.png
// module id = 508
// module chunks = 1